import { FC } from 'react';

interface ScrollToTopLinkProps {
    id: string;
    children: React.ReactNode;
    className?: string;
}

const ScrollToTopLink: FC<ScrollToTopLinkProps> = ({ 
    id, children, className 
}) => {

  const scrollToTop = () => {
    const element = document.getElementById(id);
    if (element) {
      const y:number = element.getBoundingClientRect().top + window.scrollY - 100; // Adjust for header height
      window.scrollTo({top: y, behavior: 'smooth'});
    }
  };

  return (
    <button onClick={scrollToTop} className={className}>
        {children}
    </button>
  );
}

export default ScrollToTopLink;